// Vue directive: calls the bound handler when a click happens outside the
// element it's attached to. Used to replace nativeUiBehaviors.js's global
// dropdown-outside-click detection with per-component Vue reactivity.
export default {
    bind(el, binding) {
        el.__clickOutsideHandler__ = (event) => {
            if (!(el === event.target || el.contains(event.target))) {
                binding.value(event);
            }
        };
        document.addEventListener('click', el.__clickOutsideHandler__, true);
    },
    unbind(el) {
        document.removeEventListener('click', el.__clickOutsideHandler__, true);
        delete el.__clickOutsideHandler__;
    },
};
